module.exports = __webpack_public_path__ + "static/media/ic-white-label-outsourcing.91db0740.svg";